package tta.destinigo.talktoastro.feature_profile.chat_history.data.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ChatHistoryListRequest(
    @SerialName ("page") val page: Int
)
